import { createAction, props } from '@ngrx/store';

import { IProperty } from '../../features/commons/properties/models/property.model';
import {
  CollectedType,
  ExportWidgetData,
  StatsFiltersResponse,
  StatsFlat,
  StatsForm,
  StatsRequest,
  StatsResponse,
  StatsSettings,
} from '../../models';
import { Hooks } from '../../helpers';

export const setSharePercent = createAction('[Stats] Set Share Percent');

export const load = createAction('[Stats] load');

export const setSettingsRequest = createAction(
  '[Stats] Add Settings Request',
  props<{
    settings: StatsSettings[];
  }>(),
);

export const setSettingsSuccess = createAction(
  '[Stats] Add SettingsSuccess',
  props<{
    settings: StatsSettings[];
  }>(),
);

export const setSelectedColumnsRequest = createAction(
  '[Stats] Init Selected Columns',
  props<{
    tableKey: string;
  }>(),
);

export const setSelectedColumnsSuccess = createAction(
  '[Stats] Init Selected Success',
  props<{
    selectedColumns: string[];
    settings?: StatsSettings[];
  }>(),
);

export const changePropertiesTab = createAction(
  '[Stats] Change Properties Tab',
  props<{
    filtersHeaderValues: Partial<StatsForm>;
    propertiesSelectedIds: number[];
  }>(),
);

export const SetAccommodationRowsInViewport = createAction(
  '[Stats] Set Accommodation Rows In Viewport',
  props<{
    accommodationRowsInViewport: StatsFlat[];
  }>(),
);

export const LoadAccommodationTableauNumberRequest = createAction(
  '[Stats] Load Accommodation Tableau Number Request',
  props<{
    data: Partial<StatsRequest>[];
    tableauNumbersToLoad: { parent: StatsFlat; child: StatsFlat }[];
  }>(),
);

export const LoadAccommodationTableauNumberSuccess = createAction(
  '[Stats] Load Accommodation Tableau Number Success',
  props<{
    tableauNumbers: Partial<StatsResponse>[];
    tableauNumbersToLoad: { parent: StatsFlat; child: StatsFlat }[];
  }>(),
);

export const LoadAccommodationTableauNumberFailure = createAction(
  '[Stats] Load Accommodation Tableau Number Failure',
  props<{ error: any }>(),
);

export const buildComparePeriodOptions = createAction(
  '[Stats] Build Compare Period Options',
  props<{
    min_date?: string;
  }>(),
);

export const setEnableValueChangeFilters = createAction(
  '[Stats] Set enable Value Change Filters',
);

export const setChartTypeSelected = createAction(
  '[Stats] Set Chart Type Selected',
  props<{
    translations: { currentYear: string; lastYear: string };
    chartTypeSelected: CollectedType;
  }>(),
);

export const buildFiltersOptions = createAction(
  '[Stats] Build Filters Options',
  props<{
    filtersHeaderValues?: Partial<StatsForm>;
    setInHeaderFiltersValue: boolean;
  }>(),
);

export const buildChart = createAction(
  '[Stats] Build Chart',
  props<{
    translations: { currentYear: string; lastYear: string };
  }>(),
);

export const setProperties = createAction(
  '[Stats] Set Properties',
  props<{ properties: IProperty[] }>(),
);

export const setPropertiesSelected = createAction(
  '[Stats] Set Properties Selected',
  props<{ propertiesSelectedIds: number[] }>(),
);

export const loadFiltersRequest = createAction(
  '[Stats] Load Filters Request',
  props<{
    propertyIds: number[];
  }>(),
);

export const loadFiltersSuccess = createAction(
  '[Stats] Load Filters Success',
  props<{
    filters: StatsFiltersResponse;
  }>(),
);

export const loadFiltersFailure = createAction(
  '[Stats] Load Filters Failure',
  props<{ error: any }>(),
);

export const setFiltersHeaderValues = createAction(
  '[Stats] Set Filters Data Success',
  props<{ filtersHeaderValues: Partial<StatsForm> }>(),
);

export const loadMinDateRequest = createAction(
  '[Stats] Load Min Date Request',
  props<{
    propertyIds: number[];
  }>(),
);

export const loadMinDateSuccess = createAction(
  '[Stats] Load Min Date Success',
  props<{
    min_date: string;
  }>(),
);

export const loadMinDateFailure = createAction(
  '[Stats] Load Min Date Failure',
  props<{ error: any }>(),
);

export const loadRequest = createAction(
  '[Stats] Load Request',
  props<{
    data: Partial<StatsRequest>;
    translations: {
      currentYear: string;
      lastYear: string;
      total: string;
    };
    hooks: Hooks;
  }>(),
);

export const addSplittedResponse = createAction(
  '[Stats] add splitted Response',
  props<{
    stats: Partial<StatsResponse>;
    translations: {
      currentYear: string;
      lastYear: string;
      total: string;
    };
    reservation_date_from: string;
    reservation_date_to: string;
  }>(),
);

export const loadSuccess = createAction(
  '[Stats] Load Success',
  props<{
    stats: Partial<StatsResponse>;
    translations: {
      currentYear: string;
      lastYear: string;
      total: string;
    };
  }>(),
);

export const loadFailure = createAction(
  '[Stats] Load Failure',
  props<{ error: any }>(),
);

export const clearAllRows = createAction('[Stats]  Remove All Rows');

export const clearChart = createAction('[Stats]  Remove Chart');

export const clearTotals = createAction('[Stats]  Remove Chart');

export const loadSplittedRequest = createAction(
  '[Stats] Load splitted Request',
  props<{
    data: Partial<StatsRequest>;
    translations: {
      currentYear: string;
      lastYear: string;
      total: string;
    };
    hooks?: Hooks;
  }>(),
);

export const loadSplittedSuccess = createAction(
  '[Stats] Load splitted Success',
);

export const loadSplittedFailure = createAction(
  '[Stats] Load splitted Failure',
  props<{ error: any }>(),
);

export const exportRequest = createAction(
  '[Stats] Export Request',
  props<{ data: Partial<StatsRequest>; exportData: ExportWidgetData }>(),
);

export const exportSuccess = createAction(
  '[Stats] Export Success',
  props<{ exportId: number }>(),
);

export const exportFailure = createAction(
  '[Stats] Export Failure',
  props<{ error: any }>(),
);

export const setInterruptCalls = createAction(
  '[Stats] Set Interrupt Calls',
  props<{ stop: boolean }>(),
);

export const resetState = createAction('[Stats] Reset State');
